import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import { DropdownFilterComponent } from './dropdown-filter.component';

@NgModule({
  declarations: [DropdownFilterComponent],
  imports: [
    CommonModule,
    NgbDropdownModule,
  ],
  exports: [DropdownFilterComponent],
})
export class DropdownFilterModule { }
